import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { JobService, OrderService, PrinterService } from '../../../services';
import { Job, Order } from 'app/models';
import { BsModalService } from 'ngx-bootstrap';

@Component({
  selector   : 'pdf-view-modal',
  templateUrl: 'pdf-view-modal.component.html',
  styleUrls  : ['pdf-view-modal.component.scss']
})
export class PdfViewModal implements OnInit, OnDestroy {
  @Input('pdfSource') pdfSource;
  @Input('pdfChoice') pdfChoice;
  @Input('job') job          : Job;
  @Input('order') order      : Order;
  @Input('filename') filename: String;
         zoomValue           : number  = 1;
         rotateValue         : number  = 0;
         loadFlag            : boolean = true;
         errorFlag           : boolean = false;
         rfidInnerCasePDF    : string = null;
         retryCap            : number =2 
         retry               : number =1
         constructor(
           private printerService: PrinterService,
           private orderService  : OrderService,
           private jobService    : JobService,
           private modalService  : BsModalService,
  ) { }
  
  ngOnInit(): void {
    console.log("🚀 ~ PdfViewModal ~ pdfSource:", this.pdfSource)
    console.log("🚀 ~ PdfViewModal ~ pdfChoice:", this.pdfChoice)
    console.log("🚀 ~ PdfViewModal ~ job:", this.job)

    if(!this.pdfSource) {
      console.error('Error during regenRFIDLaserFiles');
      this.errorFlag = true; // Set error state
      this.loadFlag = false; // Hide loading spinner
    }
  }

  zoom(zoomType: string) {
    if (zoomType == 'in') {
      this.zoomValue = this.zoomValue + 0.1;
    }
    else if (zoomType == 'out') {
      this.zoomValue = this.zoomValue - 0.1;
    }
  }

  rotate() {
    this.rotateValue = this.rotateValue + 90;
  }

  afterLoad(event) {
    this.loadFlag = false; // This callback ensures the loading spinner happens until we for sure have the PDF ready to load
  }

  ngOnDestroy(): void {
    console.log("Destroying...");
    this.rfidInnerCasePDF = null;
    this.loadFlag = true;
    this.pdfSource = null;
    this.pdfChoice = null;
    this.job = null;
  }

  printPDF(): void {
    if (this.pdfChoice == 'innercase') {
      let fileName = `innerCaseLabel-${this.job.orderId}-${this.job.id}.pdf`;
      this.printerService.printRFID(this.pdfSource, 'rfidInnerCaseLabel', fileName)
    }
  }

  async regenRFIDLaserFiles(type: any) {
    this.loadFlag = true; // Show loading spinner
    this.errorFlag = false; // Reset error state
    this.pdfSource = null; // Clear the PDF viewer
    try {
      const res = await this.orderService.regenRFIDLaserFiles(type, this.order.customer.outsource, this.job);
      if (res) {
        await this.getRFIDInnerCasePDF();
      } else {
        console.error('Error with regeneration inner case PDF');
      }
    } catch (error) {
      console.error('Error during regenRFIDLaserFiles:', error);
      this.errorFlag = true; // Set error state
      this.loadFlag = false; // Hide loading spinner
    } finally {
      this.pdfSource = this.rfidInnerCasePDF; // Update the PDF viewer
    }
  }

  async getRFIDInnerCasePDF() {
    const fileName = `innerCaseLabel-${this.job.orderId}-${this.job.id}.pdf`;

    console.log("🚀 ~ PdfViewModal ~ getRFIDInnerCasePDF ~ fileName:", fileName)
    try {
      this.rfidInnerCasePDF = await this.jobService.getRFIDInnerCasePDF(fileName);
      console.log('PDF retrieved successfully:', this.rfidInnerCasePDF);
    } catch (error) {
      console.error('Failed to retrieve the PDF:', error.message);
      this.rfidInnerCasePDF = null; // Reset
      throw Error('Error with getRFIDInnerCasePDF')
    }
  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/pdf-view-modal/pdf-view-modal.component.ts